import { render, staticRenderFns } from "./businesslist.vue?vue&type=template&id=0527ba9c&scoped=true"
import script from "./businesslist.vue?vue&type=script&lang=js"
export * from "./businesslist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0527ba9c",
  null
  
)

export default component.exports